export default {"src":"/_next/static/media/rp-cve.9807e27c.svg","height":35,"width":126,"blurWidth":0,"blurHeight":0};